export default __webpack_public_path__ + "static/149-bbab0395a369bf92c629929c501f4024.gif";